import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Handshake, Plus, Trash, FloppyDisk, ArrowClockwise } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const emptyPartner = () => ({ name: '', logo_url: '', link: '' });

const PartnersAdminPage = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const load = () => {
    setLoading(true);
    axios.get(`${API_URL}/api/admin/partners`, { withCredentials: true })
      .then(r => setPartners((r.data.partners && r.data.partners.length) ? r.data.partners : [emptyPartner()]))
      .catch(() => setPartners([emptyPartner()]))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const update = (i, patch) => setPartners(ps => ps.map((p, j) => j === i ? { ...p, ...patch } : p));
  const add = () => setPartners(ps => [...ps, emptyPartner()]);
  const remove = (i) => setPartners(ps => ps.filter((_, j) => j !== i));

  const save = async () => {
    setSaving(true); setSaved(false);
    try {
      await axios.put(`${API_URL}/api/admin/partners`, { partners: partners.filter(p => p.name || p.logo_url) }, { withCredentials: true });
      setSaved(true); setTimeout(() => setSaved(false), 2500);
    } catch (e) { /* noop */ } finally { setSaving(false); }
  };

  return (
    <div className="p-4 md:p-6 max-w-[820px] mx-auto" data-testid="admin-partners">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h1 className="text-[24px] font-bold text-slate-900 flex items-center gap-2"><Handshake size={24} weight="fill" className="text-rose-500" /> Partenaires & clubs</h1>
          <p className="text-slate-500 text-[14px] mt-1">Mettez en avant les clubs et associations que vous soutenez (affichés en bas du site).</p>
        </div>
        <div className="flex gap-2">
          <button onClick={load} className="px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-600 text-[13px] font-semibold flex items-center gap-2"><ArrowClockwise size={15} weight="bold" /> Recharger</button>
          <button onClick={save} disabled={saving} className="px-5 py-2 rounded-lg bg-rose-500 hover:bg-rose-600 text-white text-[13px] font-semibold flex items-center gap-2 disabled:opacity-50" data-testid="save-partners"><FloppyDisk size={15} weight="bold" /> {saving ? 'Enregistrement…' : saved ? 'Enregistré ✓' : 'Enregistrer'}</button>
        </div>
      </div>

      {loading ? (
        <div className="py-20 flex justify-center"><div className="w-8 h-8 border-2 border-rose-500 border-t-transparent rounded-full animate-spin" /></div>
      ) : (
        <div className="space-y-3">
          {partners.map((p, i) => (
            <div key={i} className="bg-white rounded-2xl border border-slate-100 p-4 grid grid-cols-1 md:grid-cols-12 gap-3 items-center" data-testid={`partner-${i}`}>
              <div className="md:col-span-2 flex items-center justify-center h-14 bg-slate-50 rounded-lg overflow-hidden">
                {p.logo_url ? <img src={p.logo_url} alt="" className="max-h-10 max-w-full object-contain" /> : <span className="text-[11px] text-slate-300">Aperçu</span>}
              </div>
              <input value={p.name} onChange={e => update(i, { name: e.target.value })} placeholder="Nom du partenaire / club"
                className="md:col-span-3 h-10 px-3 rounded-lg border border-slate-200 outline-none text-[14px]" />
              <input value={p.logo_url} onChange={e => update(i, { logo_url: e.target.value })} placeholder="URL du logo (https://…)"
                className="md:col-span-4 h-10 px-3 rounded-lg border border-slate-200 outline-none text-[13px]" />
              <input value={p.link} onChange={e => update(i, { link: e.target.value })} placeholder="Lien site (optionnel)"
                className="md:col-span-2 h-10 px-3 rounded-lg border border-slate-200 outline-none text-[13px]" />
              <button onClick={() => remove(i)} className="md:col-span-1 text-slate-300 hover:text-rose-500 flex justify-center"><Trash size={18} weight="bold" /></button>
            </div>
          ))}
          <button onClick={add} className="w-full py-4 rounded-2xl border-2 border-dashed border-slate-200 text-slate-500 hover:border-rose-300 hover:text-rose-500 font-semibold flex items-center justify-center gap-2" data-testid="add-partner"><Plus size={18} weight="bold" /> Ajouter un partenaire</button>
          <p className="text-[12px] text-slate-400 mt-2">💡 Astuce : pour le logo, collez l’URL d’une image (vous pouvez l’uploader dans « Médias » puis copier le lien).</p>
        </div>
      )}
    </div>
  );
};

export default PartnersAdminPage;
